namespace GeniuzPOS.Purchase {
    export class ReportPurTaxColumns {
        static columnsKey = 'Purchase.ReportPurTax';
    }
}
